export default {
  siret: { 
    blocks: [3, 3, 3, 5], 
    delimiter: ' ', 
    numericOnly: true 
  },
  phone: {
    phone: true,
    phoneRegionCode: "FR"
  },
  timeRange: {
    blocks: [2, 2, 2, 2, 2, 2, 2, 2], 
    delimiters: [":", "-", ":", " ", ":", "-", ":"],
    numericOnly: true,
  },
  finessNumber: {
    blocks: [3, 3, 3], 
    delimiters: [" "], 
    numericOnly: true,
    rawValueTrimPrefix: true
  },
  cipNumber: {
    blocks: [7],
    numericOnly: true
  },
  iban: {
    blocks: [4, 4, 4, 4, 4, 4, 3], 
    delimiters: [" "], 
    rawValueTrimPrefix: true
  }, 
  bic: {
    blocks: [4, 2, 2, 3], 
    delimiters: [" "], 
    rawValueTrimPrefix: true
  }
}


// WEBPACK FOOTER //
// ./src/common/Formaters.js